import { Component, inject } from '@angular/core';
// Directive for scroll animations
import { ScrollAnimateDirective } from '../../directives/scroll-animate.directive';
// Service for handling navigation to contact form
import { NavigationService } from '../../Services/navigation.service';

@Component({
  selector: 'app-hero',
  imports: [ScrollAnimateDirective],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  // Injected navigation service for smooth scrolling to contact form
  private navigationService = inject(NavigationService);

  // Navigates to contact form when "Get a Free Quote" button is clicked
  async navigateToContact(): Promise<void> {
    await this.navigationService.navigateToContactForm();
  }
}
